module.exports = __webpack_public_path__ + "static/media/wedding_gift.355d075c.png";